export interface IFrame {
  schedules: ISchedule[];
}

export interface ISchedule {
  reservationDate?: Date;
  schedule: string;
  status: string;
  capacity: number;
  reservations: number;
  remains: number;
}

export interface IFrameFilters {
  reservationDate?: Date;
}

export class FrameFiltersFormValues implements IFrameFilters {
  reservationDate?: Date = undefined;

  constructor(init?: IFrameFilters) {
    Object.assign(this, init);
  }
}
